import React, { useState } from "react";
import styles from "../SidebarButton/Navbar.module.css";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import LangButtons from './LangButtons/LangButtons';

import Montenegro from "./IconsLang/me";
import English from "./IconsLang/en";
import Russia from "./IconsLang/ru";
import Ukraine from "./IconsLang/ua";
import Albania from "./IconsLang/al";
import Turkey from "./IconsLang/tr";
import Denmark from "./IconsLang/de";

const LangButton = ({ isExpanded, onToggle }) => {
  const { lang } = useTranslation("common");
  const locale = lang || "me";
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const langMap = {
    "/me": { icon: Montenegro, text: "ME - Izaberi jezik" },
    "/en": { icon: English, text: "EN - Select language" },
    "/ru": { icon: Russia, text: "RU - Выберите язык" },
    "/ua": { icon: Ukraine, text: "UA – Виберіть мову" },
  };

  const currentLangKey = Object.keys(langMap).includes(`/${locale}`)
    ? `/${locale}`
    : "/me";

  const { icon: CurrentIcon, text: currentText } = langMap[currentLangKey];

  const dropdownLangs = Object.entries(langMap).filter(
    ([key]) => key !== currentLangKey
  );

  return (
    <>
      <div
        className={`${styles.LangButtonDivDiv}`}
        onClick={() => {
          onToggle();
          setIsMenuOpen(!isMenuOpen);
        }}
      >
        <div className={styles.sadrzajMainDugmeDropDivDiv1}>
          <div className={styles.LangButtonDropDivDiv}>
            <CurrentIcon />
            <h3 className={`${styles.LangButtonTekst} ${styles.specialFont}`}>
              {currentText}
            </h3>
          </div>
          <div className={styles.LangButtonStrelicaDiv}>
            <svg
              className={`${styles.sadrzajDugmeDropDiv2Strelica} ${isExpanded ? styles.rotirana : ""
                }`}
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon points="4,2 12,8 4,14" transform="rotate(180 8 8)" />
            </svg>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div
          className={`${styles.LangButtonDropDiv}`}
        >
          {dropdownLangs.map(([path, { text, icon }]) => (
            <a
              key={path}
              href={`${path}`}
              style={{ display: "flex", height: "40px", alignItems: "center" }}
              onClick={() => setIsMenuOpen(false)}
            >
              <LangButtons text={text} icon={path.replace("/", "")} />
            </a>
          ))}
        </div>
      )}
    </>
  );
};

export default LangButton;
